import { Component, Input } from '@angular/core';

/**
 * Generated class for the CoScreenColComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-screen-col',
  templateUrl: 'co-screen-col.html'
})
export class CoScreenColComponent {
  @Input() cell: any = {};

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/co-screen-col/co-screen-col.ts